import { useContext, useEffect, useMemo } from "react";
import { datadogRum } from "@datadog/browser-rum";
import { useI18nContext } from "@hopper-b2b/i18n";
import { ButtonWrap, MobileFloatingSection } from "@hopper-b2b/ui";
import { UserContext } from "../../App";

import CloseIcon from "../../assets/client/close.svg?react";
import TimeoutImage from "../../assets/client/timeout.svg?react";
import { closeNubankWebview } from "../../utils/nubankHandoff";
import "./styles.scss";

const ExpiredSession = () => {
  const { t } = useI18nContext();
  const { error } = useContext(UserContext);
  const handleStartNewSearch = () => {
    closeNubankWebview();
  };
  useEffect(() => {
    if (error) {
      let err = new Error("Session error: " + error);
      datadogRum.addError(err);
    }
  }, [error]);

  const errorCode = useMemo(() => {
    if (error) {
      let m = error.match(/^(\d+)_/);
      if (m != null) {
        return m[1];
      }
    }
    return null;
  }, [error]);

  return (
    <div className="nubank-invalid-session-container">
      <div className="header">
        <ButtonWrap className="back-button" onClick={handleStartNewSearch}>
          <CloseIcon className="close-icon" />
        </ButtonWrap>
      </div>
      <div className="content">
        <TimeoutImage className="timeout-image" />
        <h1>{t("expiredSessionModal.title")}</h1>
        <h4>{t("expiredSessionModal.description")}</h4>
        {errorCode && (
          <p className="error-message">
            {t("expiredSessionModal.errorCode", { errorCode })}
          </p>
        )}
      </div>
      <MobileFloatingSection
        primaryButton={{
          children: t("expiredSessionModal.confirm"),
          onClick: handleStartNewSearch,
        }}
      />
    </div>
  );
};

export default ExpiredSession;
